import { render, staticRenderFns } from "./EditarContasAPagar.vue?vue&type=template&id=668dce88&scoped=true"
import script from "./EditarContasAPagar.vue?vue&type=script&lang=js"
export * from "./EditarContasAPagar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "668dce88",
  null
  
)

export default component.exports